import { COLORS } from '../constants/colors';
const gradientKeys = ['rainbow', 'pink', 'green', 'blue', 'purple'];
export const valueIsGradientColor = (value) => gradientKeys.includes(value);
/**
 * Transforms a linear gradient string into a tuple of color and offset
 *
 * @param linearGradient - The linear gradient string to transform, e.g. `'linear-gradient(134deg, #b2ce37 0%, #63d7af 91.96%)'`
 * @returns The list of tuples of color and offset, e.g. `[['#b2ce37', '0%'], ['#63d7af', '91.96%']]`
 *
 */
export const linearGradientToTuples = (linearGradient) => {
    const [, ...stops] = linearGradient.replace('linear-gradient(', '').replace(')', '').split(',');
    return stops.map((stop) => {
        const [color, offset] = stop.trim().split(' ');
        return [color, offset];
    });
};
export const gradientColorVariant = {
    rainbow: COLORS.GRADIENT['RAINBOW-HORIZONTAL'],
    pink: COLORS.GRADIENT.PINK,
    green: COLORS.GRADIENT.GREEN,
    blue: COLORS.GRADIENT.BLUE,
    purple: COLORS.GRADIENT.PURPLE,
};
